export const truncateFileName = (fileName, maxLength) => {
    if (fileName?.length <= maxLength) {
        return fileName; // If fileName is shorter than maxLength, return it as is
    } else {
        const firstLetter = fileName?.charAt(0); // Get the first letter of the fileName
        const remainingLength = maxLength - 1; // Length remaining after considering the first letter
        const truncatedFileName = `${firstLetter}${fileName?.substring(
            1,
            remainingLength
        )}...`;
        return truncatedFileName;
    }
};



export const formatEmailAsName = (email) => {
    if (!email) return '';

    // Step 1: Process the email to remove special characters and capitalize words
    const formattedName = email
        .split(/[\W_]+/) 
        .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
        .join(' '); // Join with spaces

    // Step 2: Truncate the name to a maximum of 20 characters
    if (formattedName.length > 20) {
        return `${formattedName.slice(0, 20)}...`; 
    }

    return formattedName; 
};